import React from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Goodbye() {
  const navigate = useNavigate();

  const handleReturnLogin = () => navigate("/login");

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <Typography variant="h4" gutterBottom>
          🎉 Have a great day!
        </Typography>
        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          Your logout was successfully recorded.
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 4 }}
          onClick={() => navigate("/")}
        >
          Return to Login
        </Button>
      </Box>
    </Container>
  );
}
